var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer mt-3"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"col-12 mb-0"},[_vm._v("\n        "+_vm._s((new Date()).getFullYear())+" © Lumile - "),_c('a',{attrs:{"href":"https://www.lumile.com.ar/"}},[_vm._v("lumile.com.ar")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }